import { render, staticRenderFns } from "./free-plan.vue?vue&type=template&id=98b3f1cc&scoped=true&"
import script from "./free-plan.vue?vue&type=script&lang=js&"
export * from "./free-plan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98b3f1cc",
  null
  
)

export default component.exports